import { GraphSchema } from '@ta/server';

import { Tenant as TenantDto, tenantBrutProps } from 'src/app/services/user/dto/tenant';

import { User } from './user';

export interface Tenant extends TenantDto {
  id: string;
  userId: string;
  globalNote: number;
  user: User;
}

const props: (keyof Tenant)[] = ['userId', 'user', 'globalNote'];

export const tenantProps = new GraphSchema<Tenant>(props.concat(tenantBrutProps));
